module.exports = __webpack_public_path__ + "img/bucket.23ca7994.svg";